var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{ref:"skipLink",staticClass:"skip-to-content",attrs:{"href":"#main-heading"}},[_vm._v("\n  Zum Hauptinhalt springen\n")])}
var staticRenderFns = []

export { render, staticRenderFns }